<!--
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-07 12:00:03
 * @LastEditTime: 2021-11-23 19:00:41
 * @LastEditors: Please set LastEditors

-->
<template>
  <page-header-wrapper>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="horizontal">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.sn"
              placeholder="请输入要搜索的订单编号"
              enter-button
              allow-clear
              @search="getOrderLists()"
            />
            <a-button type="link" @click="() => (this.search = !this.search)">
              高级筛选
              <a-icon :type="search ? 'up' : 'down'" />
            </a-button>
          </div>
        </standard-form-row>
        <template v-if="search">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="优惠码">
                <a-input
                  v-model="params.where.code"
                  allow-clear
                  @pressEnter="getOrderLists()"
                  placeholder="请输入要搜索的优惠码"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="用户">
                <a-spin :spinning="coursesLoad">
                  <a-select
                    mode="multiple"
                    optionFilterProp="children"
                    showArrow
                    allow-clear
                    placeholder="请输入要搜索的用户"
                    v-model="params.where.member_id"
                    @search="getUserList"
                    @change="getOrderLists()"
                  >
                    <a-select-option v-for="item in userList" :key="item.id.toString()">
                      <template v-if="item.phone"> {{ item.phone }}-</template
                      ><template v-if="item.real_name"> {{ item.real_name }}-</template>
                      <template v-if="item.email"> {{ item.email }}</template>
                    </a-select-option>
                  </a-select>
                </a-spin>
              </a-form-item>
            </a-col>
            <a-col :md="12" :lg="8" :sm="24">
              <a-form-item label="课程">
                <a-spin :spinning="coursesLoad">
                  <a-select
                    placeholder="请选择要筛选的课程"
                    mode="multiple"
                    showArrow
                    allow-clear
                    optionFilterProp="children"
                    name="member"
                    v-model="params.where.course_id"
                    @change="value => handleSelectChange(value,{name:'coursesList'},'price_sum')"
                  >
                    <a-select-option
                      v-for="item in coursesList"
                      :key="item.id"
                      :disabled="item.disabled"
                    >
                      {{ item.title }}
                    </a-select-option>
                  </a-select>
                </a-spin>
              </a-form-item>
            </a-col>
            <a-col :md="12" :lg="8" :sm="24">
              <a-form-item label="证书">
                <a-spin :spinning="crtsLoad">
                  <a-select
                    placeholder="请选择要筛选的证书"
                    mode="multiple"
                    showArrow
                    allow-clear
                    optionFilterProp="children"
                    v-model="params.where.crt_id"
                    @change="value => handleSelectChange(value,{name: 'crtsList'},'price_sum')"
                  >
                    <a-select-option
                      v-for="item in crtsList"
                      :key="item.id"
                      :disabled="item.disabled"
                    >
                      {{ item.title }}
                    </a-select-option>
                  </a-select>
                </a-spin>
              </a-form-item>
            </a-col>
            <a-col :md="12" :lg="8" :sm="24">
              <a-form-item label="套购">
                <a-spin :spinning="packsLoad">
                  <a-select
                    placeholder="请选择要筛选的套购"
                    mode="multiple"
                    optionFilterProp="children"
                    showArrow
                    allow-clear
                    v-model="params.where.pack_id"
                    @change="value => handleSelectChange(value,{name: 'packsList'},'price_sum')"
                  >
                    <a-select-option
                      v-for="item in packsList"
                      :key="item.id"
                      :disabled="item.disabled"
                    >
                      {{ item.title }}
                    </a-select-option>
                  </a-select>
                </a-spin>
              </a-form-item>
            </a-col>

            <a-col :md="12" :lg="8" :sm="24">
              <a-form-item label="支付日期">
                <a-range-picker
                  :ranges="{
                    最近七天: [moment().subtract('days', 6), moment()],
                    今天: [moment(), moment()],
                    本月: [moment().startOf('month'), moment()]
                  }"
                  :placeholder="['开始日期', '结束日期']"
                  @change="value => handleChangeDate(value, ['pay_at_start','pay_at_end'],'price_sum')"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :lg="8" :sm="24">
              <a-form-item label="订单类型">
                <a-select
                  mode="tags"
                  allow-clear
                  placeholder="请选择订单类型"
                  v-model="params.where.source_type"
                  @change="getOrderLists()"
                >
                  <a-select-option value="1">
                    课程
                  </a-select-option>
                  <a-select-option value="2">
                    证书
                  </a-select-option>
                  <a-select-option value="3">
                    套购
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :lg="8" :sm="24">
              <a-form-item label="开票状态">
                <a-radio-group v-model="params.where.is_receipt" @change="getOrderLists()">
                  <a-radio-button value="">
                    全部
                  </a-radio-button>
                  <a-radio-button value="1">
                    未开票
                  </a-radio-button>
                  <a-radio-button value="2">
                    已开票
                  </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :md="12" :lg="8" :sm="24">
              <a-form-item label="是否退款">
                <a-radio-group v-model="params.where.refund" @change="getOrderLists()">
                  <a-radio-button value="">
                    全部
                  </a-radio-button>
                  <a-radio-button value="2">
                    是
                  </a-radio-button>
                  <a-radio-button value="1">
                    否
                  </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :md="12" :lg="8" :sm="24">
              <a-form-item label="支付方式">
                <a-select
                  mode="tags"
                  allow-clear
                  placeholder="请选择支付方式"
                  v-model="params.where.pay_type"
                  @change="getOrderLists()"
                >
                  <a-select-option value="1">
                    微信
                  </a-select-option>
                  <a-select-option value="2">
                    支付宝
                  </a-select-option>
                  <a-select-option value="3">
                    银联支付
                  </a-select-option>
                  <a-select-option value="4">
                    免费
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :lg="8" :sm="24">
              <a-form-item label="订单状态">
                <a-select
                  mode="tags"
                  allow-clear
                  placeholder="请选择订单状态"
                  v-model="params.where.state"
                  @change="getOrderLists()"
                >
                  <a-select-option value="1">
                    待支付
                  </a-select-option>
                  <a-select-option value="2">
                    已支付
                  </a-select-option>
                  <a-select-option value="3">
                    已取消
                  </a-select-option>
                  <a-select-option value="4">
                    自动取消
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </a-form>
    </a-card>

    <a-card style="margin-top: 24px;" :bordered="false" title="订单列表">
      <div slot="extra" class="change-state d-flex">
        <table-tool-bar-list
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getOrderLists()"
        />
        <export
          :columns="columns"
          :params="params"
          :url="apiList.getList"
          xlsxName="订单列表"
          v-action:export
          @click="getExportData"
        />
      </div>
      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :size="size"
        :bordered="false"
        :scroll="scroll"
      >
        <template slot="username" slot-scope="text, record">
          <a @click="handleShowUserOrder(record.member_id)">{{ text }}</a>
        </template>
        <template slot="source_type" slot-scope="text">
          <a-tag :color="sourceTypeFilter(text).color">{{ sourceTypeFilter(text).value }}</a-tag>
        </template>
        <template slot="pay_type" slot-scope="text">
          <a-tag :color="payTypeFilter(text).color">{{ payTypeFilter(text).value }}</a-tag>
        </template>
        <template slot="price" slot-scope="text">
          {{ text | NumberFormat }}
        </template>
        <template slot="pay_money" slot-scope="text">
          {{ text | NumberFormat }}
        </template>
        <template slot="codes" slot-scope="codes">
          <template v-for="(item, index) in orderGetRandomColor(codes)">
            <a-tag
              :key="index"
              :color="item.color"
              style="margin-bottom: .25rem"
              v-if="item.code"
            >
              {{ item.code }}
            </a-tag>
          </template>
        </template>
        <template slot="mode" slot-scope="text, record">
          <template v-for="(item, index) in record.codes">
            <a-tag
              :key="index"
              :color="item.color"
              style="margin-bottom: 0.25rem"
              v-if="item.mode"
            >
              {{ item.mode.name }}
            </a-tag>
          </template>
        </template>
        <template slot="is_receipt" slot-scope="text">
          <a-tag :color="receiptFilter(text).color"> {{ receiptFilter(text).value }}</a-tag>
        </template>
        <template slot="state" slot-scope="text">
          <a-tag :color="stateFilter(text).color"> {{ stateFilter(text).value }}</a-tag>
        </template>
        <template slot="refund" slot-scope="text, record">
          <a-switch
            v-action:state
            :checked="record.refund === 2"
            @change="handleChangeState(record.id)"
            checked-children="是"
            un-checked-children="否"
          />
        </template>
        <template slot="footer"> 订单累计金额：{{ price_sum }} </template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { table, list, select } from '@/mixins' // 引入
import { StandardFormRow, TableToolBarList, Export } from '@/components'
import ModelDetail from './modules/ModelDetail'
import ModelUserOrder from './modules/ModelUserOrder'
import { requestGet } from '@/api/api'
import { getRandomLightColor } from '@/utils/util'

const apiList = {
    getList: '/finances/orders',
    changeState: '/finances/orders/refund/',
    coursesList: '/courses/select',
    crtsList: '/certificates/select',
    packsList: '/courses/packs/select',
    userList: '/members/select'
}
const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        sorter: true
    },
    {
        title: '用户',
        dataIndex: 'member.real_name',
        align: 'center',
        scopedSlots: { customRender: 'username' }
    },
    {
        title: '邮箱',
        dataIndex: 'member.email'
    },
    {
        title: '电话',
        dataIndex: 'member.phone'
    },
    {
        title: '订单名称',
        dataIndex: 'title'
    },
    {
        title: '订单编号',
        dataIndex: 'sn',
        sorter: true
    },
    {
        title: '订单类型',
        dataIndex: 'source_type',
        align: 'center',
        scopedSlots: { customRender: 'source_type' }
    },
    {
        title: '优惠码标题',
        dataIndex: 'coupon.title',
        sorter: true
    },
    {
        title: '优惠码',
        dataIndex: 'coupon.code',
        sorter: true
    },
    {
        title: '支付方式',
        dataIndex: 'pay_type',
        align: 'center',
        scopedSlots: { customRender: 'pay_type' }
    },
    {
        title: '订单价格',
        dataIndex: 'price',
        sorter: true,
        align: 'center',
        scopedSlots: { customRender: 'price' }
    },
    {
        title: '支付金额',
        dataIndex: 'pay_money',
        sorter: true,
        align: 'center',
        scopedSlots: { customRender: 'pay_money' }
    },
    {
        title: '考试码',
        dataIndex: 'codes',
        sorter: true,
        width: 280,
        align: 'center',
        scopedSlots: { customRender: 'codes' }
    },
    {
        title: '考试模式',
        dataIndex: 'mode',
        sorter: true,
        width: 280,
        align: 'center',
        scopedSlots: { customRender: 'mode' }
    },
    {
        title: '是否开票',
        dataIndex: 'is_receipt',
        align: 'center',
        scopedSlots: { customRender: 'is_receipt' }
    },
    {
        title: '订单状态',
        dataIndex: 'state',
        align: 'center',
        scopedSlots: { customRender: 'state' }
    },
    {
        title: '来源',
        dataIndex: 'from'
    },
    {
        title: '活动',
        dataIndex: 'discount'
    },
    {
        title: '支付时间',
        dataIndex: 'pay_at',
        sorter: true
    },
    {
        title: '创建时间',
        dataIndex: 'created_at',
        sorter: true
    },
    {
        title: '退款',
        dataIndex: 'refund',
        width: 100,
        align: 'center',
        fixed: 'right',
        scopedSlots: { customRender: 'refund' }
    }
]
export default {
    name: 'OrderList',
    mixins: [table, list, select], // 使用mixins
    components: {
        TableToolBarList,
        StandardFormRow,
        ModelDetail,
        Export
    },
    data () {
        return {
            apiList,
            params: {
                where: {
                    state: ['2']
                }
            },
            coursesLoad: false, // 课程下拉加载
            coursesList: [], // 课程下拉数据
            packsList: [], // 套购下拉列表
            packsLoad: false, // 套购下拉加载
            crtsLoad: false, // 证书下拉加载
            crtsList: [], // 证书下拉列表
            userList: [],
            price_sum: 0,
            columns,
            settingColumns: JSON.parse(JSON.stringify(columns)) // 深度复制表头
        }
    },
    computed: {
        orderGetRandomColor (arr) {
            return function (arr) {
                const newArr = arr.filter(item => {
                    item.color = getRandomLightColor()
                    return true
                })
                return newArr
            }
        },
        receiptFilter (status) {
            return function (status) {
                const statusMap = {
                    1: { value: '未开票', color: 'red' },
                    2: { value: '已开票', color: 'green' }
                }
                return statusMap[status]
            }
        },
        stateFilter (status) {
            return function (status) {
                const statusMap = {
                    1: { value: '待支付', color: 'red' },
                    2: { value: '已支付', color: 'green' },
                    3: { value: '手动取消', color: 'green' },
                    4: { value: '自动取消', color: 'green' }
                }
                return statusMap[status]
            }
        },
        payTypeFilter (status) {
            return function (status) {
                const statusMap = {
                    1: { value: '微信', color: 'green' },
                    2: { value: '支付宝', color: 'blue' },
                    3: { value: '银联', color: 'gold' },
                    4: { value: '免费', color: 'red' }
                }
                return statusMap[status]
            }
        },
        sourceTypeFilter (status) {
            return function (status) {
                const statusMap = {
                    1: { value: '课程', color: 'pink' },
                    2: { value: '证书', color: 'red' },
                    3: { value: '套购', color: 'orange' }
                }
                return statusMap[status]
            }
        }
    },
    mounted () {
       this.getOrderLists()
        this.getSelectLists({
            url: apiList.coursesList,
            type: 'coursesList',
            load: 'coursesLoad'
        }) // 获取下拉列表
        this.getSelectLists({
            url: apiList.packsList,
            type: 'packsList',
            load: 'packsLoad'
        }) // 获取下拉列表
        this.getSelectLists({
            url: apiList.crtsList,
            type: 'crtsList',
            load: 'crtsLoad'
        }) // 获取下拉列表
        this.getSelectLists({
            url: apiList.crtsList,
            type: 'crtsList',
            load: 'crtsLoad'
        }) // 获取下拉列表
        this.getUserList() // 获取用户位列
    },
    methods: {
        /**
         * @Author: JDY
         * @Date: 2021-04-23 15:21:19
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description:获取用户下拉列表
         * @param  {*}
         * @return {*}
         * @param {*} value
         */

      // 获取列表
        getOrderLists () {
              this.getLists('price_sum')
        },
        getUserList (value) {
            requestGet('/members/select', { member: value })
                .then(res => {
                    this.userList = res.result
                })
                .catch(err => {
                    this.$notification.error(err)
                })
        },
        /**
         * @Author: JDY
         * @Date: 2021-05-17 11:07:38
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description: 整理打印考试码为字符串
         * @param  {*}
         * @return {*}
         * @param {*} codes
         */
        setCodeData (codes) {
            // eslint-disable-next-line eqeqeq
            if (codes !== '') {
              const codeString = codes.map(code => {
                return code.code
            })
            return codeString.join('&#10;')
            }
            return ''
        },
        /**
         *
         * @param {*} codes
         */
        setModeData (modes) {
         // console.log(modes)
         if (modes.mode !== '') {
          const codeString = modes.map(mode => {
              return mode.mode.name
            })
            return codeString.join('&#10;')
         }
          return ''
        },
        /**
         * 获取打印数据
         * @jdy
         *newColumns,data
         * @2020-11-30
         */
        getExportData (columns, data) {
            data.filter(item => {
                item.mode = this.setModeData(item.codes)
                item.codes = this.setCodeData(item.codes)
                item.source_type = this.sourceTypeFilter(item.source_type).value
                item.is_receipt = this.receiptFilter(item.is_receipt).value
                item.state = this.stateFilter(item.state).value
                item.pay_type = item.pay_type ? this.payTypeFilter(item.pay_type).value : '无支付信息'
            })
            this.outputXlsxFile(columns, data, '**订单列表' + this.moment(new Date()).format('YYYYMMDDHHmmss'))
        },
        /**
         * 显示用户订单弹窗
         * @jdy
         * @param
         * {user_id}
         * @2020-11-27
         */
        handleShowUserOrder (userid) {
            this.$dialog(
                ModelUserOrder,
                // component props
                {
                    userid
                },
                // modal props
                {
                    title: '用户订单',
                    centered: true,
                    maskClosable: false
                }
            )
        },

        /**
         * 弹窗展示
         * aid广告id
         * @params
         *
         * ModelDetail
         */
        handleDetailShow (item) {
            this.$dialog(
                ModelDetail,
                // component props
                {
                    userinfo: item
                },
                // modal props
                {
                    title: '用户详情',
                    width: 700,
                    centered: true,
                    maskClosable: false
                }
            )
        }
    }
}
</script>
